import { render, staticRenderFns } from "./SupplierProduct.vue?vue&type=template&id=01838e32&scoped=true"
import script from "./SupplierProduct.vue?vue&type=script&lang=ts"
export * from "./SupplierProduct.vue?vue&type=script&lang=ts"
import style0 from "./SupplierProduct.vue?vue&type=style&index=0&id=01838e32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01838e32",
  null
  
)

export default component.exports